module.exports = __webpack_public_path__ + "fonts/LetteraTextLLWeb-Regular.ad9a827.woff2";